import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from '../core/guards/auth.guard';
import { PlanningRequestsMapPage } from './planning-requests-map/planning-map-page/planning-requests-map.page';
import { PlanningMapComponent } from './planning-requests-map/components/planning-map/planning-map.component';
import { PlanningMapMenuComponent } from './planning-requests-map/components/planning-map-menu/planning-map-menu.component';
import { WorkSchedulesPage } from './work-schedules/work-schedules.page';
import { PlanningMapVisitComponent } from './planning-requests-map/components/planning-map-visit/planning-map-visit.component';
import { PlanningAutoMapComponent } from './planning-requests-map/components/planning-auto-map/planning-auto-map.component';
import { PlanningAutoMapMenuComponent } from './planning-requests-map/components/planning-auto-map-menu/planning-auto-map-menu.component';


export const planningRoutes: Routes = [
    { path: 'requests-map', component: PlanningRequestsMapPage, canActivate: [AuthGuard] },
    { path: 'work-schedules', component: WorkSchedulesPage, canActivate: [AuthGuard] },
];

@NgModule({
    imports: [],
    exports: [RouterModule]
})
export class PlanningRoutingModule {
    public static components = [
        PlanningRequestsMapPage,
        PlanningMapComponent,
        PlanningMapMenuComponent,
        WorkSchedulesPage,
        PlanningMapVisitComponent,
        PlanningAutoMapComponent,
        PlanningAutoMapMenuComponent
    ];
}